module.exports = __webpack_public_path__ + "media/step2_animation.da67476e.webm";